import React from 'react';
import { motion } from 'framer-motion';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { isEmpty, kebabCase } from 'lodash';
import BoxedContainer from '../components/layouts/BoxedContainer';
import Button from '../components/layouts/Button';
import PromotionCard from '../components/promotion-card/PromotionCard';
import { getAllPromotions } from '../services/getAllPromotions';

export default function BookingPromotionsBlock({ data }) {
  // console.log(data);
  const { title, text, image, link } = data;

  const promotions = getAllPromotions();

  if (isEmpty(promotions)) return null;
  const nullDate = '0001-01-01T00:00:00Z';
  const noDatesPromotions = promotions.filter((item) => item.startDate === nullDate);
  const datesPromotions = promotions.filter((item) => item.startDate !== nullDate);

  const sorted = [...datesPromotions, ...noDatesPromotions];

  return (
    <section
      className=" bg-bg-2 relative before:!inline before:content-[''] before:absolute
      before:top-0 before:w-full before:h-full before:bg-black before:bg-opacity-50 before:z-10"
    >
      {image && (
        <LazyLoadImage
          src={image.url}
          alt={title}
          className="w-full h-full object-cover
        absolute z-5 max-w-[100%] align-top"
        />
      )}
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.3 }}
        viewport={{ once: true }}
        className="flex items-center w-full h-full lg:pt-[95px] pt-[60px] lg:pb-[160px]
        pb-[50px] z-10 relative"
      >
        <BoxedContainer className="regular">
          <div className="lg:mb-[54px] mb-[35px]">
            <h2
              className="lg:text-2xl text-[33px] text-white leading-[50px]  flex flex-col uppercase
              font-roboto-condensed-bold"
            >
              {title}
            </h2>

            <div className="flex 2xl:flex-row flex-col lg:mt-[39px] mt-[5px]">
              {text && (
                <div className="2xl:w-[50%] w-full">
                  <p
                    className="lg:text-[16px] text-[15px] text-white leading-[30px]
                    font-roboto-regular 2xl:mt-0 mt-5"
                  >
                    {text}
                  </p>
                </div>
              )}

              <div className="2xl:w-[50%] w-full 2xl:mt-0 mt-[10px] 2xl:ml-[30px]">
                {isEmpty(link) || (
                  <Button
                    url={link.url}
                    label={link.name}
                    target={link.target}
                    external={link.target?.includes('blank')}
                    ariaLabel={link.name}
                    tagName={kebabCase(link.name)}
                    variant="primaryRed"
                    text="w-[170px] h-[45px] px-[25px] whitespace-pre"
                  />
                )}
              </div>
            </div>
          </div>
          <div className="flex justify-between flex-wrap lg:gap-[30px] gap-[20px]">
            {sorted.map((promotion, ind) => (
              <PromotionCard key={ind} data={promotion} />
            ))}
          </div>
        </BoxedContainer>
      </motion.div>
    </section>
  );
}
